import { render, staticRenderFns } from "./LayoutProduct.vue?vue&type=template&id=570a138e&scoped=true&"
import script from "./LayoutProduct.vue?vue&type=script&lang=js&"
export * from "./LayoutProduct.vue?vue&type=script&lang=js&"
import style0 from "./LayoutProduct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LayoutProduct.vue?vue&type=style&index=1&id=570a138e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a138e",
  null
  
)

export default component.exports